export default __webpack_public_path__ + "static/media/tradingPsychology-ebook.053d1d99.png";